// @flow

import React from 'react';

// mapping from Passport terminology to material icons: https://material.io/icons/
export const iconMap = {
  'add-member': 'person_add',
  alert: 'error',
  back: 'arrow_back',
  billing: 'credit_card',
  calendar: 'date_range',
  check: 'check',
  'chevron-down': 'keyboard_arrow_down',
  close: 'close',
  logout: 'exit_to_app',
  members: 'group',
  plus: 'add',
  profile: 'person',
  search: 'search',
  success: 'check_circle',
  vehicle: 'directions_car',
  menu: 'menu',
  email: 'email',
};

type Props = {
  className?: string,
  // Supported material icons
  type:
    | 'add-member'
    | 'alert'
    | 'back'
    | 'billing'
    | 'calendar'
    | 'check'
    | 'chevron-down'
    | 'close'
    | 'logout'
    | 'members'
    | 'plus'
    | 'profile'
    | 'search'
    | 'success'
    | 'vehicle'
    | 'menu'
    | 'email',
};

const defaultClassName = '';
const Icon = ({ className, type, ...props }: Props) => (
  <i {...props} className={`material-icons ${className || defaultClassName}`}>
    {iconMap[type] || type}
  </i>
);

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Icons.js